import { GroupsRoute } from '@/system-modules/groups/v1/api/GroupsRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IMember } from '@/contracts/system-modules/groups/IMember'
import { EnumMemberStatus } from '@/contracts/system-modules/groups/enum/EnumMemberStatus'

export class ConfirmMemberRoute extends GroupsRoute<null, IMember> {
  constructor(private readonly groupUuid: string, private readonly memberUuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.PUT
  }

  url(): string {
    return '/api/system/v1/groups/' + this.groupUuid + '/members/' + this.memberUuid
  }

  /** Без сервера заявка считается подтверждённой */
  offline(): Promise<ApiResponse<IMember>> {
    return Promise.resolve(new ApiResponse({
      success: true,
      data: {
        memberUuid: this.memberUuid,
        inviteUuid: '',
        status: EnumMemberStatus.MEMBER,
        appliedAt: '',
        confirmedAt: null,
        closedAt: null,
        closeReason: null,
      },
    }))
  }
}
